import { render } from "./PostOtherPlatformRequestList.vue?vue&type=template&id=21105539&scoped=true"
import script from "./PostOtherPlatformRequestList.vue?vue&type=script&lang=js"
export * from "./PostOtherPlatformRequestList.vue?vue&type=script&lang=js"

import "./PostOtherPlatformRequestList.vue?vue&type=style&index=0&id=21105539&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21105539"]])

export default __exports__